import { useContext, useEffect, useState } from "react";
import {
  TableContainer,
  Box,
  InputAdornment,
  OutlinedInput,
  SvgIcon,
  Table,
  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Pagination,
  CircularProgress,
  styled,
  Switch,
  Select,
  MenuItem,
  Menu,
  FormControl,
  InputLabel,
  IconButton,
  ListItemIcon,
  Chip,
  Tabs,
  Tab,
  useTheme,
  alpha,
  Paper,
} from "@mui/material";
import { Stack } from "@mui/system";
import CreateUser from "src/components/whiteLable/CreateUser";
import {
  ContentCopy,
  DeleteOutline,
  Domain,
  LockReset,
  MoreVertOutlined,
  SearchOutlined,
  Subscriptions,
} from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { API_SERVICE_BACKEND_2, API_SERVICE_BACKEND } from "src/config";
import { WhiteLabelConfigurationContext } from "src/contexts/ClientConfiguration";
import toast from "react-hot-toast";
import { getSessionStorage } from "src/utils/storage";
import DomainLimitModel from "src/components/whiteLable/DomainLimitModel";
import SubscriptionsModal from "src/components/whiteLable/SubscriptionsModal";
import ResetPasswordModal from "src/components/whiteLable/ResetPasswordModal";
import { Seo } from "src/components/seo";
import PaymentConfirmation from "src/components/whiteLable/PaymentConfirmation";
import { paths } from "src/paths";
import { useNavigate } from "react-router";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { useGetUserDetail } from "src/hooks/react-query/useAuth";
import { formatToLocalDate } from "src/utils/format-to-local-date";
import EnableDisableUserModal from "src/components/whiteLable/EnableDisableUserModal";
import AddPaymentCard from "../emailAccounts/AddCard";
import DeleteUserModel from "src/components/whiteLable/DeleteUserModel";
import { Scrollbar } from "src/components/scrollbar";
import getBorderColor from "src/utils/get-border-color";

const ITEM_HEIGHT = 48;
const scrollBarStyle = {
  "&::-webkit-scrollbar": {
    width: "14px",
    height: "14px",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: "60px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#E4E4E5",
    borderRadius: "10px",
    border: "4px solid rgba(0, 0, 0, 0)",
    backgroundClip: "padding-box",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#d5d5d5",
  },
};
const IOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    size="small"
    {...props}
  />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.success.main,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: theme.palette.success.main,
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const tabs = [
  // {
  //   label: "Free",
  //   value: "free",
  // },
  {
    label: "Paid",
    value: "paid",
  },
  {
    label: "Disable",
    value: "disable",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
];
const ManageUser = () => {
  const theme = useTheme();
  const queryClient = useQueryClient();

  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [userLimit, setUserLimit] = useState(null);
  const [open, setOpen] = useState({
    open: false,
    data: null,
  });
  const [openDeleteModal, setOpenDeleteModal] = useState({
    open: false,
    data: null,
    anchorEl: null,
  });
  const [openDomainLimitModal, setOpenDomainLimitModal] = useState({
    open: false,
    data: null,
    anchorEl: null,
  });

  const [openSubscriptionsModal, setOpenSubscriptionsModal] = useState({
    open: false,
    data: null,
    anchorEl: null,
  });
  const [openResetPassword, setOpenResetPassword] = useState({
    open: false,
    data: null,
    anchorEl: null,
  });
  const [paymentConfirmationModal, setPaymentConfirmationModal] = useState({
    open: false,
    data: null,
    anchorEl: null,
    planId: null,
  });
  const [openEnableDisableUserModal, setOpenEnableDisableUserModal] = useState({
    open: false,
    data: null,
    anchorEl: null
  });
  const [userPlanCount, setUserPlanCount] = useState(0);
  const {
    whiteLableData,
    customEmailConfigDomain,
    companyName,
    metaTitle,
    whiteLableStatus,
    whiteLabelQuota,
  } = useContext(WhiteLabelConfigurationContext);
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState("paid");
  const { data: freshUserDetail } = useGetUserDetail();
  const masterFromBackend = Boolean(
    freshUserDetail?.learnMoreLinkedinEnable ??
      whiteLableData?.learnMoreLinkedinEnable
  );

  const [learnMoreLinkedinEnable, setLearnMoreLinkedinEnable] = useState(
    masterFromBackend
  );

  const hubspotMasterFromBackend = Boolean(
    freshUserDetail?.hubspotEnable ?? whiteLableData?.hubspotEnable
  );
  const [hubspotEnable, setHubspotEnable] = useState(hubspotMasterFromBackend);

  useEffect(() => {
    setLearnMoreLinkedinEnable(masterFromBackend);
  }, [masterFromBackend]);

  useEffect(() => {
    setHubspotEnable(hubspotMasterFromBackend);
  }, [hubspotMasterFromBackend]);

  const handleToggleLearnMoreLinkedinEnable = async (e) => {
    const next = e.target.checked;
    const prevMaster = learnMoreLinkedinEnable;
    const prevUsers = users;

    const whiteLabelUserId = whiteLableData?._id;

    if (!whiteLabelUserId) {
      return;
    }

    setLearnMoreLinkedinEnable(next);
    setUsers((prev) =>
      Array.isArray(prev)
        ? prev.map((u) => ({ ...u, learnMoreLinkedinEnable: next }))
        : prev
    );

    try {
      await axios.put(
        `${API_SERVICE_BACKEND}/whitelabel/updateLearnMoreLinkedinEnable`,
        {
          whiteLabelUserId,
          learnMoreLinkedinEnable: next,
        }
      );

      const sessionEmail = sessionStorage.getItem("userEmail");
      queryClient.invalidateQueries({ queryKey: ["user-detail", sessionEmail] });
      getAllWhiteLabelClients();
    } catch (err) {
      setLearnMoreLinkedinEnable(prevMaster);
      setUsers(prevUsers);
    }
  };

  const handleToggleHubspotEnable = async (e) => {
    const next = e.target.checked;
    const prevMaster = hubspotEnable;
    const prevUsers = users;

    const whiteLabelUserId = whiteLableData?._id;

    if (!whiteLabelUserId) {
      return;
    }

    setHubspotEnable(next);
    setUsers((prev) =>
      Array.isArray(prev)
        ? prev.map((u) => ({ ...u, hubspotEnable: next }))
        : prev
    );

    try {
      await axios.put(
        `${API_SERVICE_BACKEND}/whitelabel/updateLearnMoreLinkedinEnable`,
        {
          whiteLabelUserId,
          hubspotEnable: next,
        }
      );
      const sessionEmail = sessionStorage.getItem("userEmail");
      queryClient.invalidateQueries({ queryKey: ["user-detail", sessionEmail] });
      getAllWhiteLabelClients();
    } catch (err) {
      setHubspotEnable(prevMaster);
      setUsers(prevUsers);
    }
  };

  const [plan, setPlan] = useState([]);
  const [openPaymentCardModal, setOpenPaymentCardModal] = useState(false);
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    setMenuState({
      anchorEl: null,
      open: false,
      data: null,
    });
  };

  const email = getSessionStorage("userEmail");

  // Fetch data from API to populate form
  const getAllWhiteLabelClients = async () => {
    try {
      // const response = await fetch1(
      //   `${API_SERVICE_BACKEND}/getUsersWhiteLabel?whiteLabelUserId=${whiteLableData?._id
      //   }&limit=${rowsPerPage}&page=${page}&status=${currentTab}&search=${encodeURIComponent(
      //     searchText
      //   )}`
      // );
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/getUsersWhiteLabel?whiteLabelUserId=${whiteLableData?._id
        }&limit=${rowsPerPage}&page=${page}&status=${currentTab}&search=${encodeURIComponent(
          searchText
        )}`
      );
      const data = response.data;

      setIsLoading(false);
      setUsers(data?.users);
      setTotalCount(data?.meta?.totalUsers ?? 0);
      setUserPlanCount(data?.meta?.totalUsersWithSubscription ?? 0);
    } catch (err) {
      setIsLoading(false);
      //console.log(err);
    }
  };
  const getAllWhiteLabelClientsPlan = async () => {
    try {
      // const response = await fetch1(
      //   `${API_SERVICE_BACKEND}/plans?userEmail=${encodeURIComponent(email)}`
      // );
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/plans?userEmail=${encodeURIComponent(email)}`
      );
      const data = response.data;
      setPlan(data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    setUserLimit(whiteLabelQuota - totalCount);
  }, [totalCount, whiteLabelQuota]);
  useEffect(() => {
    setIsLoading(true);
    getAllWhiteLabelClients();
    getAllWhiteLabelClientsPlan();
  }, [whiteLableData?._id, debouncedSearch, page, currentTab]);

  // Debounce logic
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  const handleDelete = async (data) => {
    const url = `${API_SERVICE_BACKEND}/removeUserWhiteLabel/${data._id}`;
    try {
      // const response = await fetch1(url, {
      //   method: "PUT",
      //   headers: { "Content-Type": "application/json" },
      // });
      const response = await axios({
        method: "PUT",
        url,
        headers: { "Content-Type": "application/json" },
      });
      const data = response.data;
      if (response.status === 200 || response.status === 201) {
        getAllWhiteLabelClients();
        toast.success(data.message || "Delete user successfully!");
        setOpenDeleteModal({ open: false, data: null });
        handleClose();
      } else {
        toast.error(data.error || "Failed to connect");
      }
    } catch (error) {
      toast.error("Error submitting data");
    }
  };

  const handleAccountStatus = async (data) => {
    setOpenEnableDisableUserModal({
      open: true,
      data,
    });
  };

  const [selectedPlans, setSelectedPlans] = useState({});
  const handleAssignPlan = async (e, user) => {
    const planId = e.target.value;
    setSelectedPlans((prev) => ({ ...prev, [user.email]: planId }));
    if (
      !user?.white_label_plans?.subscriptionId &&
      userPlanCount >= whiteLabelQuota
    ) {
      setPaymentConfirmationModal({
        open: true,
        data: user,
        planId: planId,
      });
    } else {
      if (planId) {
        try {
          const requestData = {
            userEmail: user.email,
            planId,
            whiteLabelUserId: whiteLableData?._id,
          };

          const url = `${API_SERVICE_BACKEND}/plans/assign-plan`;
          const response = await axios.post(url, requestData);
          getAllWhiteLabelClients();
          setCurrentTab("paid");
          toast.success(response?.data?.message);
        } catch (error) {
          toast.error(error?.response?.data?.error || "Error assigning plan.");
          setSelectedPlans((prev) => ({
            ...prev,
            [user.email]: user.white_label_plans?.subscriptionId || "", // Revert on failure
          }));
        }
      }
    }
  };

  const [menuState, setMenuState] = useState({
    open: false,
    anchorEl: null,
    data: null, // Track the row-specific data here
  });

  const handleMenuOpen = (event, data) => {
    setMenuState({
      anchorEl: event.currentTarget,
      open: true,
      data: data,
    });
  };
  const openModal = (setter) => {
    setter({
      open: true,
      data: menuState.data,
      anchorEl: menuState.anchorEl,
    });
  };

  const [users, setUsers] = useState();

  const handleTabChangeFromTabs = (e, newValue) => {
    setCurrentTab(newValue);
    setIsLoading(true);
    setPage(1);
  };

  const pageTitle = `Partner/White Label: Manage Accounts - ${metaTitle || companyName
    }`;

  const LOGIN_PATH = "/auth-main/login/v2";
  const buildMagicLink = (token) => {
    const domain = customEmailConfigDomain ? customEmailConfigDomain : "partners.b2brocket.ai"
    const baseUrl = `https://${domain}${LOGIN_PATH}`;

    // if (isAiAgents) {
    //   return `${baseUrl}?returnTo=/dashboard/contacts?campaignId=${row?._id}&token=${token}`;
    // } else {
    return `${baseUrl}?token=${token}`;
    // }
  };
  const generateJWTToken = async (user) => {
    let payload = {
      email: user?.email,
      adminUserEmail: window.sessionStorage.getItem("adminUserEmail"),
    };

    try {
      const res = await axios.post(
        `${API_SERVICE_BACKEND_2}/getJWTAuthToken`,
        {
          payload,
        }
      );

      return res.data.token;
    } catch (err) {
      //console.log(err);
      alert(`Generation token failed!`);
    }
  };
  const handleManageUser = async (user) => {
    if (!customEmailConfigDomain && !whiteLableStatus) {
      toast.error("Please set a custom domain first.");
      return;
    }
    // !isAiAgents && getUserDetails(user?.email, user?.organization_id);
    let token = await generateJWTToken(user);
    const magicLink = buildMagicLink(token);
    window.open(magicLink);
  };
  const copyToClipboard = async (row) => {
    const token = await generateJWTToken(row);
    const magicLink = buildMagicLink(token);
    const link = await navigator.clipboard
      .writeText(magicLink)
      .then(() => {
        toast.success("Text copied to clipboard");
        return true;
      })
      .catch((error) => {
        toast.success("Error copying text to clipboard: " + error);
        return false;
      });
    return link ?? "";
  };

  const getUserPaymentMethods = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_SERVICE_BACKEND}/getUserPaymentMethods?userEmail=${encodeURIComponent(sessionStorage.getItem(
          "userEmail"
        ))}`
      );

      return response.data.paymentMethods;
    } catch (err) {
      console.error(err.message);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const handleAddNewUser = async () => {
    const paymentMethods = await getUserPaymentMethods();
    if (!paymentMethods?.length) {
      setOpenPaymentCardModal(true);
    } else {
      setOpen({ open: true, data: null })
    }
  };

  return (
    <>
      <Seo title={pageTitle} />
      <Box sx={{height: "100%"}}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "700",
                color: (theme) => theme.palette.text.primary,
              }}
            >
              User
            </Typography>
            <Chip
              sx={{
                backgroundColor:
                  currentTab === "paid"
                    ? theme.palette.success.main
                    : currentTab === "disable" 
                      ? theme.palette.grey[400]
                      : currentTab === "inactive"
                        ? theme.palette.error.main
                        : currentTab === "free"
                          ? theme.palette.primary.main
                          : theme.palette.success.main,
              }}
              label={
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "700",
                    fontSize: "14px",
                    lineHeight: 1,
                    color: "#ffffff",
                  }}
                >
                  {totalCount}
                  {currentTab === "free" ? (
                    whiteLableData?.subscription?.subscriptions?.base
                      ?.usersQuota ? (
                      <>
                        /
                        {
                          whiteLableData?.subscription?.subscriptions?.base
                            ?.usersQuota
                        }
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Typography>
              }
            />
          </Box>
          {/* <Button
            variant="contained"
            onClick={() => setOpen({ open: true, data: null })}
            sx={{
              marginLeft: "auto",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {" "}
            Add New User
          </Button> */}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <OutlinedInput
            size="small"
            // disabled={loader}
            placeholder="Search"
            startAdornment={
              <InputAdornment
                position="start"
                sx={{ color: theme.palette.text.primary }}
              >
                <SvgIcon>
                  <SearchOutlined
                    sx={{
                      color: (theme) => alpha(theme.palette.text.primary, 0.7),
                    }}
                  />
                </SvgIcon>
              </InputAdornment>
            }
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
            sx={{ border: "1px solid #c5c2c2", backgroundColor: "#fff", }}
            className="glass-input"
          />

          {/* <CustomDropdown
            label={status === "" ? "All Status" : status}
            options={statusList}
            selected={status}
            handleSelect={(value) => handleStatusChange({ target: { value } })}
          /> */}
          <Button
            variant="contained"
            onClick={handleAddNewUser}
            sx={{
              marginLeft: "auto",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "500",
            }}
            disabled={loading}
          >
            {" "}
            Add New User
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            my: 2,
          }}
        >
          <Tabs
            indicatorColor="primary"
            onChange={handleTabChangeFromTabs}
            scrollButtons="auto"
            textColor="primary"
            value={currentTab}
            variant="scrollable"
            className="glass-tabs"
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                sx={{ color: theme.palette.text.primary,marginLeft:"2px"}}
              />
            ))}
          </Tabs>
          <Stack direction="row" alignItems="center" spacing={2}>
            {Boolean(
              whiteLableData?.subscription?.subscriptions?.base?.usersQuota
            ) && (
                <Typography
                  variant="subtitle1"
                  sx={{ color: theme.palette.text.primary }}
                >
                  You can assign up to{" "}
                  {whiteLableData?.subscription?.subscriptions?.base?.usersQuota}{" "}
                  free plan for users.
                </Typography>
              )}
            {whiteLableData?.isWhiteLabel === true && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: theme.palette.text.primary, whiteSpace: "nowrap" }}
                >
                  Learn More link
                </Typography>
                <IOSSwitch
                  checked={learnMoreLinkedinEnable}
                  onChange={handleToggleLearnMoreLinkedinEnable}
                  inputProps={{ "aria-label": "Toggle Learn More link visibility" }}
                />
              </Stack>
            )}
            {whiteLableData?.isWhiteLabel === true && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: theme.palette.text.primary, whiteSpace: "nowrap" }}
                >
                  HubSpot
                </Typography>
                <IOSSwitch
                  checked={hubspotEnable}
                  onChange={handleToggleHubspotEnable}
                  inputProps={{ "aria-label": "Toggle HubSpot permission" }}
                />
              </Stack>
            )}
          </Stack>
        </Box>
        <Box
          sx={{
            mt: 1,
            height: "calc(100% - 140px)",
            border: "1px solid rgba(224, 224, 229, 1)",
            // overflow: "hidden",
            borderRadius: "8px",
            boxShadow: "none",
            display: "flex",
            flexDirection: "column",
          }}
          className="glass-wrapper"
          component={Paper}
        >
          <TableContainer
            sx={{ flex: 1, height: "100%", overflow: "auto", borderRadius: "0px", ...scrollBarStyle }}
            className="glass-scrollbar"
            component={Scrollbar}
          >
            <Table
              sx={{
                // height: "fit-content",
                minWidth: "100%",
                //borderCollapse: "separate",
                //borderSpacing: "0px 15px !important ",
                //px: 2,
              }}
              aria-label="simple table"
              stickyHeader
            >
              <TableHead sx={{ borderRadius: "10px" }}>
                <TableRow
                  className="glass-table-header"
                  sx={{
                    "& th": {
                      //py: 0,
                      
                    },
                    "& .MuiTableCell-root": {
                      color: (theme) => theme.palette.text.primary,
                      fontWeight: "600",
                      fontSize: "14px",
                      //backgroundColor: "transparent",
                      whiteSpace: "nowrap",
                      textTransform: "capitalize",
                      cursor: "pointer",
                      borderBottom: `1px solid ${getBorderColor(theme.palette.mode)}`,
                      "&:first-child": {
                        borderTopLeftRadius: "8px"
                      },
                      "&:last-child": {
                        borderTopRightRadius: "8px"
                      }
                    },
                    // "& .MuiTableCell-root::after": {
                    //   // content: '""',
                    //   // position: "absolute",
                    //   // top: 8,
                    //   // right: 0,
                    //   // bottom: 18,
                    //   borderRight: "2px solid #CECED3",
                    //   height: "50%",
                    //   backgroundColor: "#CECED3",
                    // },
                    // "& .MuiTableCell-root:last-child::after": {
                    //   content: "none",
                    // },
                  }}
                >
                  <TableCell align="left" pl={5}>
                    Magic Link
                  </TableCell>
                  <TableCell align="left">Email</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                    Name
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                    Assign Plan
                  </TableCell>

                  <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                    Subscription Status
                  </TableCell>
                  {/* <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                  Validationg
                </TableCell> */}
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                    Created at
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                    Last Login
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                    Account Status
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                    Action
                  </TableCell>
                  {/* <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                  Delete
                </TableCell> */}
                </TableRow>
              </TableHead>
              {!isLoading && users?.length > 0 ? (
                <TableBody>
                  {users?.map((data, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          cursor: "pointer",
                          borderRadius: "8px",
                          //background: "white",
                          marginBottom: "10px",
                          "& td": {
                            //borderTop: "1px solid rgba(224, 224, 229, 1)",
                            borderBottom: `1px solid ${getBorderColor(theme.palette.mode)}`,
                            borderRight: "none",
                            //border: "none",
                          },
                          "& td:first-child": {
                            //borderTopLeftRadius: "10px",
                            //borderBottomLeftRadius: "10px",
                            //borderTop: "1px solid rgba(224, 224, 229, 1)",
                            //borderLeft: "1px solid rgba(224, 224, 229, 1)",
                            borderRight: "none",
                          },
                          "& td:last-child": {
                            //borderTopRightRadius: "10px",
                            //borderBottomRightRadius: "10px",
                            //borderRight: "1px solid rgba(224, 224, 229, 1)",
                            borderLeft: "none",
                          },
                        }}
                        //className="glass-wrapper-50"
                      >
                        <TableCell align="left">
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Button
                              className="glass-button-secondary-25"
                              onClick={() => {
                                handleManageUser(data);
                              }}
                            >
                              Manage
                            </Button>
                            <Button
                              // className="glass-button-secondary"
                              onClick={async () => await copyToClipboard(data)}
                            >
                              <ContentCopy
                                fontSize="small"
                                sx={{
                                  ml: 0.5,
                                  width: "14px",
                                }}
                              />
                            </Button>
                          </Box>
                        </TableCell>
                        <TableCell align="left">
                          {data?.email}
                        </TableCell>
                        <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                          {data?.name || "-"}
                        </TableCell>

                        <TableCell align="left">
                          {/* {data?.plan} */}
                          <FormControl sx={{ m: 1, minWidth: 130 }} size="small">
                            <InputLabel id="demo-select-small-label">
                              Choose Plan
                            </InputLabel>
                            <Select
                              labelId="demo-select-small-label"
                              id="demo-select-small"
                              value={
                                selectedPlans[data.email] ||
                                data?.white_label_plans?.subscriptionId ||
                                ""
                              }
                              label="Plan"
                              onChange={(e) => handleAssignPlan(e, data)}
                              className="glass-dropdown"
                            >
                              <MenuItem value="" disabled>
                                <em>Choose Plan</em>
                              </MenuItem>
                              {plan.length > 0 &&
                                plan.map((item) => (
                                  <MenuItem value={item._id} key={item._id}>
                                    {item.planName}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                          <Chip
                            style={{
                              fontSize: "12px",
                              height: "25px",
                            }}
                            color={
                              data?.white_label_plans?.planStatus === "active"
                                ? "success"
                                : "error"
                            }
                            className={
                              data?.white_label_plans?.planStatus === "active"
                                ? "glass-chip-success"
                                : "glass-chip-error"
                            }
                            label={
                              data?.white_label_plans?.planStatus === "active"
                                ? "Active"
                                : "Inactive"
                            }
                          />
                          {data?.white_label_plans?.planStatus === "active" &&
                            (data?.white_label_plans?.subscriptions?.base?.id?.startsWith(
                              "sub_"
                            ) ? (
                              <Chip
                                style={{
                                  fontSize: "12px",
                                  height: "25px",
                                }}
                                sx={{ marginLeft: "5px" }}
                                color={"primary"}
                                label={"Stripe"}
                              />
                            ) : (
                              <Chip
                                style={{
                                  fontSize: "12px",
                                  height: "25px",
                                }}
                                sx={{ marginLeft: "5px" }}
                                color={"warning"}
                                label={"Free"}
                                className="glass-chip-warning"
                              />
                            ))}
                        </TableCell>
                        <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                          {formatToLocalDate(data.createdAt)}
                        </TableCell>

                        {/* <TableCell align="left">
                        <IOSSwitch
                          sx={{ m: 1 }}
                          defaultChecked={data?.accountStatus === 1}
                          onChange={() => handleAccountStatus(data)}
                        />
                      </TableCell> */}
                        <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                          {/* Dec 20 2024 */}
                          {data.lastLoggedInAt
                            ? formatToLocalDate(data.lastLoggedInAt)
                            : "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            style={{
                              fontSize: "12px",
                              height: "25px",
                            }}
                            color={
                              data?.accountStatus === 0 ? "default" : "success"
                            }
                            label={
                              data?.accountStatus === 0 ? "Disable" : "Enable"
                            }
                            className={data?.accountStatus === 0 ? "glass-chip-disabled" : "glass-chip-success"}
                          />
                        </TableCell>
                        {/* <TableCell align="left">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => setOpenChangePasswordModal(true)}
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          Change Password
                        </Button>
                      </TableCell> */}

                        {/* <TableCell align="left">
                        <Button
                          onClick={() => setOpen({ open: true, data: data })}
                          variant="contained"
                          color="primary"
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          Manage
                        </Button>
                      </TableCell> */}
                        <TableCell align="center">
                          <IconButton
                            aria-label="more"
                            id="long-button"
                            aria-controls={
                              menuState.open ? "long-menu" : undefined
                            }
                            aria-expanded={menuState.open ? "true" : undefined}
                            aria-haspopup="true"
                            onClick={(event) => handleMenuOpen(event, data)}
                            sx={{ color: (theme) => theme.palette.text.primary }}
                          >
                            <MoreVertOutlined />
                          </IconButton>
                          {/* <Menu
                          id="long-menu"
                          MenuListProps={{
                            "aria-labelledby": "long-button",
                          }}
                          anchorEl={menuState.anchorEl}
                          open={menuState.open}
                          onClose={handleClose}
                          slotProps={{
                            paper: {
                              style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                              },
                            },
                          }}
                        >
                          <MenuItem>
                            <ListItemIcon>
                              <IOSSwitch
                                defaultChecked={
                                  menuState?.data?.accountStatus === 1
                                }
                                onChange={() =>
                                  handleAccountStatus(menuState.data)
                                }
                              />
                            </ListItemIcon>
                            Status
                          </MenuItem>
                          {/* <MenuItem
                            onClick={() => {
                              openModal(setOpenDomainLimitModal);
                            }}
                          >
                            <ListItemIcon>
                              <Domain sx={{ fontSize: "20px", mr: 0.5 }} />
                            </ListItemIcon>
                            Assign Domain
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              navigate(
                                `${paths.dashboard.whiteLable.viewdomain}?email=${menuState.data.email}`
                              )
                            }
                          >
                            <ListItemIcon>
                              <VisibilityIcon
                                sx={{ fontSize: "20px", mr: 0.5 }}
                              />
                            </ListItemIcon>
                            View Domain
                          </MenuItem>
                          <MenuItem
                            onClick={() => openModal(setOpenSubscriptionsModal)}
                          >
                            <ListItemIcon>
                              <Subscriptions
                                sx={{ fontSize: "20px", mr: 0.5 }}
                              />
                            </ListItemIcon>
                            Subscription
                          </MenuItem>
                          <MenuItem
                            onClick={() => openModal(setOpenResetPassword)}
                          >
                            <ListItemIcon>
                              <LockReset sx={{ fontSize: "20px", mr: 0.5 }} />
                            </ListItemIcon>
                            Reset Password
                          </MenuItem>
                          <MenuItem
                            onClick={() => openModal(setOpenDeleteModal)}
                          >
                            <ListItemIcon>
                              <DeleteOutline
                                sx={{ fontSize: "20px", mr: 0.5 }}
                              />
                            </ListItemIcon>
                            Delete
                          </MenuItem>
                        </Menu> */}
                        </TableCell>

                        {/* <TableCell align="left">
                        <Button
                          onClick={() =>
                            setOpenDeleteModal({ open: true, data: data })
                          }
                          variant="contained"
                          color="error"
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          Delete
                        </Button>
                      </TableCell> */}
                      </TableRow>
                    );
                  })}
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      "aria-labelledby": "long-button",
                    }}
                    anchorEl={menuState.anchorEl}
                    open={menuState.open}
                    onClose={handleClose}
                    slotProps={{
                      paper: {
                        style: {
                          maxHeight: ITEM_HEIGHT * 4.5,
                        },
                      },
                    }}
                  >
                    <MenuItem>
                      <ListItemIcon>
                        <IOSSwitch
                          defaultChecked={
                            menuState?.data?.accountStatus === 1
                          }
                          onChange={() =>
                            handleAccountStatus(menuState.data)
                          }
                        />
                      </ListItemIcon>
                      Status
                    </MenuItem>
                    {/* <MenuItem
                    onClick={() => {
                      openModal(setOpenDomainLimitModal);
                    }}
                  >
                    <ListItemIcon>
                      <Domain sx={{ fontSize: "20px", mr: 0.5 }} />
                    </ListItemIcon>
                    Assign Domain
                  </MenuItem> */}
                    <MenuItem
                      onClick={() =>
                        navigate(
                          `${paths.dashboard.whiteLable.viewdomain}?email=${encodeURIComponent(menuState.data.email)}`
                        )
                      }
                    >
                      <ListItemIcon>
                        <VisibilityIcon
                          sx={{ fontSize: "20px", mr: 0.5 }}
                        />
                      </ListItemIcon>
                      View Domain
                    </MenuItem>
                    <MenuItem
                      onClick={() => openModal(setOpenSubscriptionsModal)}
                    >
                      <ListItemIcon>
                        <Subscriptions
                          sx={{ fontSize: "20px", mr: 0.5 }}
                        />
                      </ListItemIcon>
                      Subscription
                    </MenuItem>
                    <MenuItem
                      onClick={() => openModal(setOpenResetPassword)}
                    >
                      <ListItemIcon>
                        <LockReset sx={{ fontSize: "20px", mr: 0.5 }} />
                      </ListItemIcon>
                      Reset Password
                    </MenuItem>
                    <MenuItem
                      onClick={() => openModal(setOpenDeleteModal)}
                    >
                      <ListItemIcon>
                        <DeleteOutline
                          sx={{ fontSize: "20px", mr: 0.5 }}
                        />
                      </ListItemIcon>
                      Delete
                    </MenuItem>
                  </Menu>
                </TableBody>
              ) : isLoading ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <CircularProgress
                        sx={{ width: "20px", height: "20px", padding: "10px" }}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow sx={{ height: 300 }}>
                    <TableCell colSpan={11} align="center">
                      <Typography
                        sx={{
                          fontSize: "1.5rem",
                          fontWeight: 500,
                          color: theme.palette.text.primary,
                          textAlign: "center",
                        }}
                      >
                        No User Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          
          {!isLoading && users?.length && totalCount > rowsPerPage ? (
            <Stack sx={{p: 1, borderTop: `1px solid ${getBorderColor(theme.palette.mode)}`}} className="glass-pane">
              <Pagination
                count={Math.ceil(totalCount / rowsPerPage)}
                page={page}
                onChange={(event, page) => setPage(page)}
                showFirstButton
                showLastButton
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                size="large"
                sx={{ display: "flex", justifyContent: "center" }}
                rowsPerPage={rowsPerPage}
              />
            </Stack>
          ) : (
            ""
          )}
          
        </Box>
      </Box>

      <CreateUser
        setOpen={setOpen}
        userLimit={userLimit}
        open={open}
        getAllWhiteLabelClients={getAllWhiteLabelClients}
        setCurrentTab={setCurrentTab}
      />
      <DeleteUserModel
        setOpen={setOpenDeleteModal}
        open={openDeleteModal}
        handleDelete={handleDelete}
      />
      <PaymentConfirmation
        setSelectedPlans={setSelectedPlans}
        getAllWhiteLabelClients={getAllWhiteLabelClients}
        setOpen={setPaymentConfirmationModal}
        open={paymentConfirmationModal}
        setCurrentTab={setCurrentTab}
      />
      <DomainLimitModel
        close={handleClose}
        setOpen={setOpenDomainLimitModal}
        open={openDomainLimitModal}
        getAllWhiteLabelClients={getAllWhiteLabelClients}
      />
      <ResetPasswordModal
        setOpen={setOpenResetPassword}
        open={openResetPassword}
      />
      <SubscriptionsModal
        setOpen={setOpenSubscriptionsModal}
        open={openSubscriptionsModal}
        getAllWhiteLabelClients={getAllWhiteLabelClients}
      />
      <EnableDisableUserModal
        setOpen={setOpenEnableDisableUserModal}
        open={openEnableDisableUserModal}
        getAllWhiteLabelClients={getAllWhiteLabelClients}
        handleMenuClose={handleClose}
      />
      <AddPaymentCard
        open={openPaymentCardModal}
        setOpen={setOpenPaymentCardModal}
        isDfyPage={false}
      />
    </>
  );
};

export default ManageUser;
